var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: _vm.isNew ? "Nueva Facturación" : "Editar Facturación",
        centered: "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "hide-footer": "",
        size: "lg"
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "b-overlay",
        {
          attrs: {
            variant: "white",
            show: _vm.loadingData || _vm.saving,
            "spinner-variant": "primary",
            blur: "0",
            opacity: ".75",
            rounded: "sm"
          }
        },
        [
          _c(
            "b-form",
            {
              attrs: { autocomplete: "off", "data-vv-scope": "newBillingForm" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("div", { staticClass: "mt-3" }, [
                _c("h4", { staticClass: "text-primary" }, [
                  _vm._v("Configuración de ejecución")
                ]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c(
                    "div",
                    { staticClass: "col col-6" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Esta activo" } },
                        [
                          _c("b-form-checkbox", {
                            attrs: {
                              id: "emisor.status",
                              name: "emisor.status",
                              value: true,
                              "unchecked-value": false,
                              "data-cy": "newBillingForm.emisor.status"
                            },
                            model: {
                              value: _vm.emisor.status,
                              callback: function($$v) {
                                _vm.$set(_vm.emisor, "status", $$v)
                              },
                              expression: "emisor.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col col-6" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Emitir como borrador" } },
                        [
                          _c("b-form-checkbox", {
                            attrs: {
                              id: "emisor.saveAsDraf",
                              name: "emisor.saveAsDraf",
                              value: true,
                              "unchecked-value": false,
                              "data-cy": "newBillingForm.emisor.saveAsDraft"
                            },
                            model: {
                              value: _vm.emisor.saveAsDraf,
                              callback: function($$v) {
                                _vm.$set(_vm.emisor, "saveAsDraf", $$v)
                              },
                              expression: "emisor.saveAsDraf"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "mt-3" }, [
                _c("div", { staticClass: "row mt-2" }, [
                  _c(
                    "div",
                    { staticClass: "col col-6" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Tipo de factura (*)" } },
                        [
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "",
                              name: "newBillingForm.emisor.type",
                              danger: _vm.errors.has(
                                "newBillingForm.emisor.type"
                              ),
                              "danger-text": _vm.errors.first(
                                "newBillingForm.emisor.type"
                              ),
                              "data-vv-as": "Tipo de factura",
                              options: _vm.typeOptions,
                              reduce: function(option) {
                                return option.value
                              },
                              "data-cy": "newBillingForm.emisor.type"
                            },
                            model: {
                              value: _vm.emisor.type,
                              callback: function($$v) {
                                _vm.$set(_vm.emisor, "type", $$v)
                              },
                              expression: "emisor.type"
                            }
                          }),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first("newBillingForm.emisor.type")
                                ) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col col-6" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Emitir el día (*)" } },
                        [
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "",
                              name: "newBillingForm.emisor.dayType",
                              danger: _vm.errors.has(
                                "nnewBillingForm.emisor.dayType"
                              ),
                              "danger-text": _vm.errors.first(
                                "newBillingForm.emisor.dayType"
                              ),
                              "data-vv-as": "Emitir el día",
                              options: _vm.daysOptions,
                              reduce: function(option) {
                                return option.value
                              }
                            },
                            model: {
                              value: _vm.emisor.dayType,
                              callback: function($$v) {
                                _vm.$set(_vm.emisor, "dayType", $$v)
                              },
                              expression: "emisor.dayType"
                            }
                          }),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "newBillingForm.emisor.dayType"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.emisor.dayType === "otro"
                    ? _c(
                        "div",
                        { staticClass: "col col-6" },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Dia de emisión (*)" } },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min_value:1|max_value:28",
                                    expression:
                                      "'required|min_value:1|max_value:28'"
                                  }
                                ],
                                attrs: {
                                  id: "newBillingForm.emisor.day",
                                  name: "newBillingForm.emisor.day",
                                  "data-cy": "newBillingForm.emisor.day",
                                  placeholder: "1",
                                  "data-vv-as": "Dia de emisión",
                                  state: _vm.errors.has(
                                    "newBillingForm.emisor.day"
                                  )
                                    ? false
                                    : null,
                                  danger: _vm.errors.has(
                                    "newBillingForm.emisor.day"
                                  ),
                                  "danger-text": _vm.errors.first(
                                    "newBillingForm.emisor.day"
                                  ),
                                  type: "number",
                                  min: 1,
                                  max: 28
                                },
                                model: {
                                  value: _vm.emisor.day,
                                  callback: function($$v) {
                                    _vm.$set(_vm.emisor, "day", $$v)
                                  },
                                  expression: "emisor.day"
                                }
                              }),
                              _c("b-form-invalid-feedback", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "newBillingForm.emisor.day"
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "col col-6" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Hora de emisión" } },
                        [
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "",
                              name: "newBillingForm.emisor.hour",
                              danger: _vm.errors.has(
                                "nnewBillingForm.emisor.hour"
                              ),
                              "danger-text": _vm.errors.first(
                                "newBillingForm.emisor.hour"
                              ),
                              "data-vv-as": "Hora",
                              options: _vm.hoursOptions,
                              reduce: function(option) {
                                return option.value
                              },
                              "data-cy": "newBillingForm.emisor.hour"
                            },
                            model: {
                              value: _vm.emisor.hour,
                              callback: function($$v) {
                                _vm.$set(_vm.emisor, "hour", $$v)
                              },
                              expression: "emisor.hour"
                            }
                          }),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first("newBillingForm.emisor.hour")
                                ) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col col-6" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Es factura en cuotas" } },
                        [
                          _c("b-form-checkbox", {
                            attrs: {
                              id: "emisor.esEnCuota",
                              name: "emisor.esEnCuota",
                              value: true,
                              "unchecked-value": false,
                              "data-cy": "newBillingForm.emisor.esEnCuota"
                            },
                            model: {
                              value: _vm.emisor.esEnCuota,
                              callback: function($$v) {
                                _vm.$set(_vm.emisor, "esEnCuota", $$v)
                              },
                              expression: "emisor.esEnCuota"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !_vm.emisor.esEnCuota
                    ? _c(
                        "div",
                        { staticClass: "col col-6" },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Fecha de vigencia" } },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "today",
                                    expression: "'today'"
                                  }
                                ],
                                attrs: {
                                  id: "newBillingForm.emisor.validityDate",
                                  name: "newBillingForm.emisor.validityDate",
                                  "data-cy":
                                    "newBillingForm.emisor.validityDate",
                                  placeholder: "1",
                                  "data-vv-as": "Fecha de vigencia",
                                  state: _vm.errors.has(
                                    "newBillingForm.emisor.validityDate"
                                  )
                                    ? false
                                    : null,
                                  danger: _vm.errors.has(
                                    "newBillingForm.emisor.validityDate"
                                  ),
                                  "danger-text": _vm.errors.first(
                                    "newBillingForm.emisor.validityDate"
                                  ),
                                  type: "date",
                                  min: _vm.minDate
                                },
                                model: {
                                  value: _vm.emisor.validityDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.emisor, "validityDate", $$v)
                                  },
                                  expression: "emisor.validityDate"
                                }
                              }),
                              _c(
                                "small",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value:
                                        "Posterior a esta fecha, ya no se ejecutará esta configuración",
                                      expression:
                                        "'Posterior a esta fecha, ya no se ejecutará esta configuración'"
                                    }
                                  ],
                                  staticClass: "text-muted"
                                },
                                [_vm._v(" Vigencia de la configuración ")]
                              ),
                              _c("b-form-invalid-feedback", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "newBillingForm.emisor.validityDate"
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.emisor.esEnCuota
                    ? _c(
                        "div",
                        { staticClass: "col col-6" },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Número de cuotas" } },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min_value:1",
                                    expression: "'required|min_value:1'"
                                  }
                                ],
                                attrs: {
                                  id: "newBillingForm.emisor.numCuotas",
                                  name: "newBillingForm.emisor.numCuotas",
                                  "data-cy": "newBillingForm.emisor.numCuotas",
                                  placeholder: "12",
                                  "data-vv-as": "Número de cuotas"
                                },
                                model: {
                                  value: _vm.emisor.numCuotas,
                                  callback: function($$v) {
                                    _vm.$set(_vm.emisor, "numCuotas", $$v)
                                  },
                                  expression: "emisor.numCuotas"
                                }
                              }),
                              _c("b-form-invalid-feedback", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "newBillingForm.emisor.numCuotas"
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.emisor.esEnCuota
                    ? _c(
                        "div",
                        { staticClass: "col col-6" },
                        [
                          _c(
                            "b-form-group",
                            { attrs: { label: "Número de cuota inicial" } },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min_value:1",
                                    expression: "'required|min_value:1'"
                                  }
                                ],
                                attrs: {
                                  id: "newBillingForm.emisor.numCuota",
                                  name: "newBillingForm.emisor.numCuota",
                                  "data-cy": "newBillingForm.emisor.numCuota",
                                  placeholder: "1",
                                  "data-vv-as": "Número de cuota inicial"
                                },
                                model: {
                                  value: _vm.emisor.numCuota,
                                  callback: function($$v) {
                                    _vm.$set(_vm.emisor, "numCuota", $$v)
                                  },
                                  expression: "emisor.numCuota"
                                }
                              }),
                              _c("b-form-invalid-feedback", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first(
                                        "newBillingForm.emisor.numCuota"
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]),
              _c("div", { staticClass: "mt-3" }, [
                _c("h4", { staticClass: "text-primary" }, [
                  _vm._v("Información del emisor")
                ]),
                _c("div", { staticClass: "row mt-3" }, [
                  _c("div", { staticClass: "col col-6" }, [
                    _c("small", [_vm._v("Rut:")]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" " + _vm._s(_vm.company.iut) + " ")
                  ]),
                  _c("div", { staticClass: "col col-6" }, [
                    _c("small", [_vm._v("Razón Social:")]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" " + _vm._s(_vm.company.razonSocial) + " ")
                  ])
                ]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c(
                    "div",
                    { staticClass: "col col-6" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Sucursal (*)" } },
                        [
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "",
                              label: "direccion",
                              name: "newBillingForm.emisor.sucursal",
                              danger: _vm.errors.has(
                                "newBillingForm.emisor.sucursal"
                              ),
                              "danger-text": _vm.errors.first(
                                "newBillingForm.emisor.sucursal"
                              ),
                              "data-vv-as": "Sucursal",
                              options: _vm.branches,
                              reduce: function(option) {
                                return option.sucursalId
                              },
                              "data-cy": "newBillingForm.emisor.sucursal"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("feather-icon", {
                                      attrs: {
                                        icon:
                                          option.casaMatriz === "Y"
                                            ? "HomeIcon"
                                            : "GlobeIcon",
                                        "v-b-tooltip":
                                          option.casaMatriz === "Y"
                                            ? "Casa Matriz"
                                            : "Sucursal",
                                        color:
                                          option.casaMatriz === "Y"
                                            ? "green"
                                            : "red"
                                      }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(option.direccion) +
                                        " " +
                                        _vm._s(option.comuna) +
                                        " " +
                                        _vm._s(option.ciudad) +
                                        " "
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.emisor.sucursal,
                              callback: function($$v) {
                                _vm.$set(_vm.emisor, "sucursal", $$v)
                              },
                              expression: "emisor.sucursal"
                            }
                          }),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "newBillingForm.emisor.sucursal"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "mt-3" }, [
                _c("h4", { staticClass: "text-primary" }, [
                  _vm._v("Información del Receptor")
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col col-6" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-3",
                          attrs: {
                            label: "Rut",
                            "label-for": "newBillingForm.receptor.iut"
                          }
                        },
                        [
                          _c("b-form-input-rut", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|validateRut",
                                expression: "'required|validateRut'"
                              }
                            ],
                            staticClass: "w-full",
                            attrs: {
                              id: "newBillingForm.receptor.iut",
                              label: "Rut (*)",
                              maxlength: "10",
                              name: "newBillingForm.receptor.iut",
                              "data-cy": "newBillingForm.receptor.iut",
                              "data-vv-as": "Rut",
                              state: _vm.errors.has(
                                "newBillingForm.receptor.iut"
                              )
                                ? false
                                : null,
                              danger: _vm.errors.has(
                                "newBillingForm.receptor.iut"
                              ),
                              "danger-text": _vm.errors.first(
                                "newBillingForm.receptor.iut"
                              ),
                              placeholder: "12345678-1"
                            },
                            on: {
                              change: _vm.onChangeReceiver,
                              blur: _vm.onChangeReceiver
                            },
                            model: {
                              value: _vm.receptor.iut,
                              callback: function($$v) {
                                _vm.$set(_vm.receptor, "iut", $$v)
                              },
                              expression: "receptor.iut"
                            }
                          }),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "newBillingForm.receptor.iut"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col col-6" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-3",
                          attrs: {
                            "data-vv-as": "Nombre / Razón social",
                            label: "Nombre / Razón social",
                            "label-for": "newBillingForm.receptor.razonSocial"
                          }
                        },
                        [
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              id: "newBillingForm.receptor.razonSocial",
                              name: "newBillingForm.receptor.razonSocial",
                              placeholder: "Nombre",
                              "data-vv-as": "Nombre",
                              label: "Razón social (*)",
                              "data-cy": "newBillingForm.receptor.razonSocial",
                              state: _vm.errors.has(
                                "newBillingForm.receptor.razonSocial"
                              )
                                ? false
                                : null,
                              danger: _vm.errors.has(
                                "newBillingForm.receptor.razonSocial"
                              ),
                              "danger-text": _vm.errors.first(
                                "newBillingForm.receptor.razonSocial"
                              ),
                              disabled: _vm.receiverLoading
                            },
                            model: {
                              value: _vm.receptor.razonSocial,
                              callback: function($$v) {
                                _vm.$set(_vm.receptor, "razonSocial", $$v)
                              },
                              expression: "receptor.razonSocial"
                            }
                          }),
                          _vm.receiverLoading
                            ? _c("b-spinner", {
                                key: "primary",
                                staticClass: "mr-1",
                                attrs: { variant: "primary" }
                              })
                            : _vm._e(),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "newBillingForm.receptor.razonSocial"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col col-6" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Sucursal (*)" } },
                        [
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "",
                              label: "direccion",
                              id: "newBillingForm.receptor.sucursal",
                              name: "newBillingForm.receptor.sucursal",
                              "data-cy": "newBillingForm.receptor.sucursal",
                              danger: _vm.errors.has(
                                "newBillingForm.receptor.sucursal"
                              ),
                              "danger-text": _vm.errors.first(
                                "newBillingForm.receptor.sucursal"
                              ),
                              "data-vv-as": "Sucursal",
                              options: _vm.branchesReceiver,
                              reduce: function(option) {
                                return option.sucursalId
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("feather-icon", {
                                      attrs: {
                                        icon:
                                          option.casaMatriz === "Y"
                                            ? "HomeIcon"
                                            : "GlobeIcon",
                                        "v-b-tooltip":
                                          option.casaMatriz === "Y"
                                            ? "Casa Matriz"
                                            : "Sucursal",
                                        color:
                                          option.casaMatriz === "Y"
                                            ? "green"
                                            : "red"
                                      }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(option.direccion) +
                                        " " +
                                        _vm._s(option.comuna) +
                                        " " +
                                        _vm._s(option.ciudad) +
                                        " "
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.receptor.sucursal,
                              callback: function($$v) {
                                _vm.$set(_vm.receptor, "sucursal", $$v)
                              },
                              expression: "receptor.sucursal"
                            }
                          }),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "newBillingForm.receptor.sucursal"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "mt-3" }, [
                _c("h4", { staticClass: "text-primary" }, [
                  _vm._v("Datos de la facturación")
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col col-6" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Moneda de emisión (*)" } },
                        [
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "",
                              name: "newBillingForm.detalle.moneda",
                              "data-cy": "newBillingForm.detalle.moneda",
                              danger: _vm.errors.has(
                                "newBillingForm.detalle.moneda"
                              ),
                              "danger-text": _vm.errors.first(
                                "newBillingForm.detalle.moneda"
                              ),
                              "data-vv-as": "Emitir el día",
                              options: _vm.currenciesOptions,
                              reduce: function(option) {
                                return option.value
                              }
                            },
                            model: {
                              value: _vm.detalle.moneda,
                              callback: function($$v) {
                                _vm.$set(_vm.detalle, "moneda", $$v)
                              },
                              expression: "detalle.moneda"
                            }
                          }),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "newBillingForm.detalle.moneda"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c(
                    "div",
                    { staticClass: "col col-6" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-3",
                          attrs: {
                            "data-vv-as": "Monto",
                            label: "Monto",
                            "label-for": "newBillingForm.monto"
                          }
                        },
                        [
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|min_value:1",
                                expression: "'required|min_value:1'"
                              }
                            ],
                            attrs: {
                              id: "newBillingForm.detalle.monto",
                              name: "newBillingForm.detalle.monto",
                              type: "number",
                              "data-cy": "newBillingForm.detalle.monto",
                              placeholder: "1234.5",
                              "data-vv-as": "Monto",
                              label: "Monto (*)",
                              state: _vm.errors.has(
                                "newBillingForm.detalle.monto"
                              )
                                ? false
                                : null,
                              danger: _vm.errors.has(
                                "newBillingForm.detalle.monto"
                              ),
                              "danger-text": _vm.errors.first(
                                "newBillingForm.detalle.monto"
                              )
                            },
                            model: {
                              value: _vm.detalle.monto,
                              callback: function($$v) {
                                _vm.$set(_vm.detalle, "monto", $$v)
                              },
                              expression: "detalle.monto"
                            }
                          }),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "newBillingForm.detalle.monto"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col col-3" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "El monto es bruto" } },
                        [
                          _c("b-form-checkbox", {
                            attrs: {
                              id: "newBillingForm.detalle.bruto",
                              name: "newBillingForm.detalle.bruto",
                              "data-cy": "newBillingForm.detalle.bruto",
                              value: true,
                              "unchecked-value": false
                            },
                            model: {
                              value: _vm.detalle.bruto,
                              callback: function($$v) {
                                _vm.$set(_vm.detalle, "bruto", $$v)
                              },
                              expression: "detalle.bruto"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col  col-12" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-3",
                          attrs: {
                            "data-vv-as": "Descripción",
                            label: "Descripción de la factura",
                            "label-for": "newBillingForm.monto"
                          }
                        },
                        [
                          _c(
                            "Taggeable",
                            { attrs: { keys: ["{{"], items: _vm.tagsItems } },
                            [
                              _c("b-form-textarea-tags", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:80",
                                    expression: "'required|max:80'"
                                  }
                                ],
                                attrs: {
                                  id: "newBillingForm.detalle.descripcion",
                                  name: "newBillingForm.detalle.descripcion",
                                  type: "text",
                                  "data-cy":
                                    "newBillingForm.detalle.descripcion",
                                  placeholder:
                                    "Factura del mes {{mes_anterior}} ",
                                  "data-vv-as": "Descripción",
                                  label: "Descripción (*)",
                                  state: _vm.errors.has(
                                    "newBillingForm.detalle.descripcion"
                                  )
                                    ? false
                                    : null,
                                  danger: _vm.errors.has(
                                    "newBillingForm.detalle.descripcion"
                                  ),
                                  "danger-text": _vm.errors.first(
                                    "newBillingForm.detalle.descripcion"
                                  ),
                                  tags: _vm.tagsItems
                                },
                                model: {
                                  value: _vm.detalle.descripcion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.detalle, "descripcion", $$v)
                                  },
                                  expression: "detalle.descripcion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.detalle.descripcion.length >= 60
                            ? _c(
                                "small",
                                {
                                  staticClass:
                                    "textarea-counter-value float-right",
                                  class:
                                    _vm.detalle.descripcion.length >= 80
                                      ? "bg-danger"
                                      : ""
                                },
                                [
                                  _c("span", { staticClass: "char-count" }, [
                                    _vm._v(
                                      _vm._s(_vm.detalle.descripcion.length)
                                    )
                                  ]),
                                  _vm._v(" / 80 ")
                                ]
                              )
                            : _vm._e(),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "newBillingForm.detalle.descripcion"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col  col-12" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-3",
                          attrs: {
                            "data-vv-as": "Detalle",
                            label: "Detalle de la factura",
                            "label-for": "newBillingForm.monto"
                          }
                        },
                        [
                          _c(
                            "Taggeable",
                            { attrs: { keys: ["{{"], items: _vm.tagsItems } },
                            [
                              _c("b-form-textarea-tags", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "max:1000",
                                    expression: "'max:1000'"
                                  }
                                ],
                                attrs: {
                                  id: "newBillingForm.detalle",
                                  name: "newBillingForm.detalle",
                                  type: "text",
                                  "data-cy": "newBillingForm.detalle",
                                  placeholder:
                                    "Factura del mes {{mes_anterior}} ",
                                  "data-vv-as": "Detalle",
                                  label: "Descripción (*)",
                                  state: _vm.errors.has(
                                    "newBillingForm.detalle"
                                  )
                                    ? false
                                    : null,
                                  danger: _vm.errors.has(
                                    "newBillingForm.detalle"
                                  ),
                                  "danger-text": _vm.errors.first(
                                    "newBillingForm.detalle"
                                  ),
                                  tags: _vm.tagsItems
                                },
                                model: {
                                  value: _vm.detalle.detalle,
                                  callback: function($$v) {
                                    _vm.$set(_vm.detalle, "detalle", $$v)
                                  },
                                  expression: "detalle.detalle"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.detalle.detalle.length >= 800
                            ? _c(
                                "small",
                                {
                                  staticClass:
                                    "textarea-counter-value float-right",
                                  class:
                                    _vm.detalle.detalle.length >= 1000
                                      ? "bg-danger"
                                      : ""
                                },
                                [
                                  _c("span", { staticClass: "char-count" }, [
                                    _vm._v(_vm._s(_vm.detalle.detalle.length))
                                  ]),
                                  _vm._v(" / 1000 ")
                                ]
                              )
                            : _vm._e(),
                          _c("b-form-invalid-feedback", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first("newBillingForm.detalle")
                                ) +
                                " "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("div", { staticClass: "col col-12" }, [
                      _c("h4", { staticClass: "text-primary" }, [
                        _vm._v("Referencias")
                      ]),
                      _c(
                        "div",
                        { staticClass: "text-right" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: "Agregar Referencia",
                                expression: "'Agregar Referencia'"
                              }
                            ],
                            staticClass: "cursor-pointer",
                            attrs: {
                              size: "25",
                              icon: "PlusCircleIcon",
                              color: "green",
                              "data-cy": "modal-reference"
                            },
                            on: {
                              click: function($event) {
                                return _vm.openModalReferences()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      _vm._l(_vm.references, function(savedReference, index) {
                        return _c("div", { key: index, staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col col-1" },
                            [
                              _c("feather-icon", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip",
                                    value: "Eliminar Referencia",
                                    expression: "'Eliminar Referencia'"
                                  }
                                ],
                                staticClass: "mt-10 cursor-pointer",
                                attrs: {
                                  size: "25",
                                  "data-cy": "delete-custom",
                                  icon: "TrashIcon",
                                  color: "red"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteReference(index)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-3" },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Fecha (*)" } },
                                [
                                  _c("b-form-input", {
                                    staticClass: "w-full",
                                    attrs: {
                                      "data-cy": "referenceDate",
                                      readonly: "",
                                      type: "date"
                                    },
                                    model: {
                                      value: savedReference.fecha,
                                      callback: function($$v) {
                                        _vm.$set(savedReference, "fecha", $$v)
                                      },
                                      expression: "savedReference.fecha"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-5" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-3",
                                  attrs: { label: "Tipo documento (*)" }
                                },
                                [
                                  _c("v-select", {
                                    staticClass: "w-full",
                                    attrs: {
                                      "data-cy": "referenceType",
                                      autocomplete: "",
                                      readonly: "",
                                      options: _vm.documentTypes
                                    },
                                    model: {
                                      value: savedReference.tipoDocumento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          savedReference,
                                          "tipoDocumento",
                                          $$v
                                        )
                                      },
                                      expression: "savedReference.tipoDocumento"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          savedReference.tipoDocumento &&
                          _vm.reference.tipoDocumento === "0"
                            ? _c(
                                "div",
                                { staticClass: "col-3" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-3",
                                      attrs: { label: "Documento (*)" }
                                    },
                                    [
                                      _c("b-form-input", {
                                        staticClass: "w-full",
                                        attrs: {
                                          "data-cy": "referenceOtherDocument",
                                          maxlength: "3",
                                          readonly: ""
                                        },
                                        model: {
                                          value: savedReference.documento,
                                          callback: function($$v) {
                                            _vm.$set(
                                              savedReference,
                                              "documento",
                                              $$v
                                            )
                                          },
                                          expression: "savedReference.documento"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "col-2" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-3",
                                  attrs: { label: "Global" }
                                },
                                [
                                  _c("b-form-checkbox", {
                                    attrs: {
                                      value: true,
                                      "unchecked-value": false
                                    },
                                    model: {
                                      value: savedReference.global,
                                      callback: function($$v) {
                                        _vm.$set(savedReference, "global", $$v)
                                      },
                                      expression: "savedReference.global"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-3" },
                            [
                              !savedReference.global
                                ? _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-3",
                                      attrs: { label: "Folio" }
                                    },
                                    [
                                      _c("b-form-input", {
                                        staticClass: "w-full",
                                        attrs: { readonly: "" },
                                        model: {
                                          value: savedReference.folio,
                                          callback: function($$v) {
                                            _vm.$set(
                                              savedReference,
                                              "folio",
                                              $$v
                                            )
                                          },
                                          expression: "savedReference.folio"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "mb-8",
                                  attrs: { label: "Motivo (*)" }
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "w-full",
                                    attrs: { readonly: "" },
                                    model: {
                                      value: savedReference.motivo,
                                      callback: function($$v) {
                                        _vm.$set(savedReference, "motivo", $$v)
                                      },
                                      expression: "savedReference.motivo"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col col-1" })
                        ])
                      }),
                      0
                    ),
                    _c(
                      "b-modal",
                      {
                        ref: "modal-references",
                        attrs: {
                          size: "xl",
                          "no-close-on-backdrop": "",
                          title: "Agregar referencia",
                          "hide-footer": ""
                        }
                      },
                      [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "form",
                            {
                              attrs: {
                                novalidate: "",
                                "data-vv-scope": "form-3"
                              }
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-1" }),
                                _c(
                                  "div",
                                  { staticClass: "col-3" },
                                  [
                                    _c(
                                      "b-form-group",
                                      { attrs: { label: "Fecha (*)" } },
                                      [
                                        _c("b-form-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass: "w-full",
                                          attrs: {
                                            "data-cy": "referenceDate",
                                            name: "referenceDate",
                                            "data-vv-as": "fecha",
                                            state: _vm.errors.has(
                                              "form-3.referenceDate"
                                            )
                                              ? false
                                              : null,
                                            danger: _vm.errors.has(
                                              "form-3.referenceDate"
                                            ),
                                            "danger-text": _vm.errors.first(
                                              "form-3.referenceDate"
                                            ),
                                            type: "date"
                                          },
                                          model: {
                                            value: _vm.reference.date,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.reference,
                                                "date",
                                                $$v
                                              )
                                            },
                                            expression: "reference.date"
                                          }
                                        }),
                                        _c("b-form-invalid-feedback", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "form-3.referenceDate"
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-5" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-3",
                                        attrs: { label: "Tipo documento (*)" }
                                      },
                                      [
                                        _c("v-select", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass: "w-full",
                                          attrs: {
                                            "data-cy": "referenceType",
                                            autocomplete: "",
                                            name: "referenceType",
                                            "data-vv-as": "tipo documento",
                                            state: _vm.errors.has(
                                              "form-3.referenceType"
                                            )
                                              ? false
                                              : null,
                                            danger: _vm.errors.has(
                                              "form-3.referenceType"
                                            ),
                                            "danger-text": _vm.errors.first(
                                              "form-3.referenceType"
                                            ),
                                            options: _vm.documentTypes
                                          },
                                          model: {
                                            value: _vm.reference.type,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.reference,
                                                "type",
                                                $$v
                                              )
                                            },
                                            expression: "reference.type"
                                          }
                                        }),
                                        _c("b-form-invalid-feedback", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "form-3.referenceType"
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm.reference.type &&
                                _vm.reference.type.value === "0"
                                  ? _c(
                                      "div",
                                      { staticClass: "col-3" },
                                      [
                                        _c(
                                          "b-form-group",
                                          {
                                            staticClass: "mb-3",
                                            attrs: { label: "Documento (*)" }
                                          },
                                          [
                                            _c("b-form-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: {
                                                    required:
                                                      _vm.reference.type
                                                        .value === "0",
                                                    max: 3
                                                  },
                                                  expression:
                                                    "{ required: reference.type.value === '0', max: 3 }"
                                                }
                                              ],
                                              staticClass: "w-full",
                                              attrs: {
                                                "data-cy":
                                                  "referenceOtherDocument",
                                                name: "referenceOtherDocument",
                                                "data-vv-as": "tipo documento",
                                                maxlength: "3",
                                                state: _vm.errors.has(
                                                  "form-3.referenceOtherDocument"
                                                )
                                                  ? false
                                                  : null,
                                                danger: _vm.errors.has(
                                                  "form-3.referenceOtherDocument"
                                                ),
                                                "danger-text": _vm.errors.first(
                                                  "form-3.referenceOtherDocument"
                                                )
                                              },
                                              model: {
                                                value:
                                                  _vm.reference.otherDocument,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.reference,
                                                    "otherDocument",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "reference.otherDocument"
                                              }
                                            }),
                                            _c("b-form-invalid-feedback", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "form-3.referenceOtherDocument"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "col-2" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-3",
                                        attrs: { label: "Global" }
                                      },
                                      [
                                        _c("b-form-checkbox", {
                                          attrs: {
                                            name: "referenceGlobal",
                                            value: true,
                                            "unchecked-value": false,
                                            "data-cy": "referenceGlobal"
                                          },
                                          model: {
                                            value: _vm.reference.global,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.reference,
                                                "global",
                                                $$v
                                              )
                                            },
                                            expression: "reference.global"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-3" },
                                  [
                                    !_vm.reference.global
                                      ? _c(
                                          "b-form-group",
                                          {
                                            staticClass: "mb-3",
                                            attrs: { label: "Folio" }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "w-full",
                                              attrs: {
                                                "data-cy": "referenceNumber",
                                                name: "referenceNumber",
                                                "data-vv-as": "folio",
                                                state: _vm.errors.has(
                                                  "form-3.referenceNumber"
                                                )
                                                  ? false
                                                  : null,
                                                danger: _vm.errors.has(
                                                  "form-3.referenceNumber"
                                                ),
                                                "danger-text": _vm.errors.first(
                                                  "form-3.referenceNumber"
                                                )
                                              },
                                              model: {
                                                value: _vm.reference.number,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.reference,
                                                    "number",
                                                    $$v
                                                  )
                                                },
                                                expression: "reference.number"
                                              }
                                            }),
                                            _c("b-form-invalid-feedback", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "form-3.referenceNumber"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-6" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-8",
                                        attrs: { label: "Motivo (*)" }
                                      },
                                      [
                                        _c("b-form-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass: "w-full",
                                          attrs: {
                                            "data-cy": "referenceReason",
                                            name: "referenceReason",
                                            "data-vv-as": "motivo",
                                            state: _vm.errors.has(
                                              "form-3.referenceReason"
                                            )
                                              ? false
                                              : null,
                                            danger: _vm.errors.has(
                                              "form-3.referenceReason"
                                            ),
                                            "danger-text": _vm.errors.first(
                                              "form-3.referenceReason"
                                            )
                                          },
                                          model: {
                                            value: _vm.reference.reason,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.reference,
                                                "reason",
                                                $$v
                                              )
                                            },
                                            expression: "reference.reason"
                                          }
                                        }),
                                        _c("b-form-invalid-feedback", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "form-3.referenceReason"
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-1" },
                                  [
                                    _c("feather-icon", {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName: "v-b-modal",
                                          value: "modal-references",
                                          expression: "'modal-references'"
                                        },
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip",
                                          value: "Agregar Referencia",
                                          expression: "'Agregar Referencia'"
                                        }
                                      ],
                                      staticClass: "mt-10 cursor-pointer",
                                      attrs: {
                                        size: "25",
                                        icon: "PlusCircleIcon",
                                        color: "green",
                                        "data-cy": "add-reference"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.addReference()
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col  col-12" }, [
                    _c("h4", { staticClass: "text-primary" }, [
                      _vm._v("Personalizados")
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col  col-12" },
                    [
                      _vm._l(_vm.personalizados, function(personalizado) {
                        return _c(
                          "div",
                          { key: personalizado.nombre, staticClass: "row" },
                          [
                            _c(
                              "div",
                              { staticClass: "col col-1" },
                              [
                                personalizado.eliminar
                                  ? _c("feather-icon", {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip",
                                          value: "Eliminar Personalizado",
                                          expression: "'Eliminar Personalizado'"
                                        }
                                      ],
                                      staticClass: "mt-10 cursor-pointer",
                                      attrs: {
                                        size: "25",
                                        "data-cy": "delete-custom",
                                        icon: "TrashIcon",
                                        color: "red"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteCustom(personalizado)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col  col-3" },
                              [
                                _c(
                                  "vs-select",
                                  {
                                    staticClass: "w-100",
                                    attrs: {
                                      autocomplete: "",
                                      label: "Tipo",
                                      name:
                                        "newBillingForm.personalizado." +
                                        personalizado.nombre +
                                        ".tipo",
                                      danger: _vm.errors.has(
                                        "newBillingForm.personalizado." +
                                          personalizado.nombre +
                                          ".tipo"
                                      ),
                                      "danger-text": _vm.errors.first(
                                        "newBillingForm.personalizado." +
                                          personalizado.nombre +
                                          ".tipo"
                                      ),
                                      "data-vv-as": "Tipo",
                                      disabled: true
                                    },
                                    model: {
                                      value: personalizado.tipo,
                                      callback: function($$v) {
                                        _vm.$set(personalizado, "tipo", $$v)
                                      },
                                      expression: "personalizado.tipo"
                                    }
                                  },
                                  [
                                    _c("vs-select-item", {
                                      attrs: {
                                        value: _vm.customType.CUSTOM_TYPE_TEXT,
                                        text: "Texto"
                                      }
                                    }),
                                    _c("vs-select-item", {
                                      attrs: {
                                        value: _vm.customType.CUSTOM_TYPE_DATE,
                                        text: "Fecha"
                                      }
                                    }),
                                    _c("vs-select-item", {
                                      attrs: {
                                        value:
                                          _vm.customType.CUSTOM_TYPE_NUMBER,
                                        text: "Número"
                                      }
                                    }),
                                    _c("vs-select-item", {
                                      attrs: {
                                        value:
                                          _vm.customType.CUSTOM_TYPE_OPTIONS,
                                        disabled: "",
                                        text: "Opciones"
                                      }
                                    }),
                                    _c("vs-select-item", {
                                      attrs: {
                                        value:
                                          _vm.customType.CUSTOM_TYPE_CURRENCY,
                                        disabled: "",
                                        text: "Moneda"
                                      }
                                    }),
                                    _c("vs-select-item", {
                                      attrs: {
                                        value:
                                          _vm.customType
                                            .CUSTOM_TYPE_RATE_EXCHANGE,
                                        disabled: "",
                                        text: "Tasa Cambio"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col  col-3" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-3",
                                    attrs: {
                                      label: "Nombre",
                                      "label-for":
                                        "newBillingForm.personalizado." +
                                        personalizado.nombre +
                                        ".nombre"
                                    }
                                  },
                                  [
                                    _c("b-form-input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate"
                                        }
                                      ],
                                      staticClass: "w-full",
                                      attrs: {
                                        id:
                                          "newBillingForm.personalizado." +
                                          personalizado.nombre +
                                          ".nombre",
                                        name:
                                          "newBillingForm.personalizado." +
                                          personalizado.nombre +
                                          ".nombre",
                                        "data-cy":
                                          "newBillingForm.personalizado." +
                                          personalizado.nombre +
                                          ".nombre",
                                        "data-vv-as": personalizado.nombre,
                                        state: _vm.errors.has(
                                          "newBillingForm.personalizado." +
                                            personalizado.nombre +
                                            ".nombre"
                                        )
                                          ? false
                                          : null,
                                        danger: _vm.errors.has(
                                          "newBillingForm.personalizado." +
                                            personalizado.nombre +
                                            ".nombre"
                                        ),
                                        "danger-text": _vm.errors.first(
                                          "newBillingForm.personalizado." +
                                            personalizado.nombre +
                                            ".nombre"
                                        ),
                                        disabled: ""
                                      },
                                      model: {
                                        value: personalizado.nombre,
                                        callback: function($$v) {
                                          _vm.$set(personalizado, "nombre", $$v)
                                        },
                                        expression: "personalizado.nombre"
                                      }
                                    }),
                                    _c("b-form-invalid-feedback", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.errors.first(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".nombre"
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col  col-4" },
                              [
                                +personalizado.tipo ===
                                _vm.customType.CUSTOM_TYPE_DATE
                                  ? _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-3",
                                        attrs: {
                                          "label-for":
                                            "newBillingForm.personalizado." +
                                            personalizado.nombre +
                                            ".valor",
                                          label: "Valor"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass: "w-full",
                                          attrs: {
                                            id:
                                              "newBillingForm.personalizado." +
                                              personalizado.nombre +
                                              ".valor",
                                            name:
                                              "newBillingForm.personalizado." +
                                              personalizado.nombre +
                                              ".valor",
                                            "data-cy":
                                              "newBillingForm.personalizado." +
                                              personalizado.nombre +
                                              ".valor",
                                            type: "date",
                                            "data-vv-as": personalizado.nombre,
                                            state: _vm.errors.has(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            )
                                              ? false
                                              : null,
                                            danger: _vm.errors.has(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            ),
                                            "danger-text": _vm.errors.first(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            )
                                          },
                                          model: {
                                            value: personalizado.valor,
                                            callback: function($$v) {
                                              _vm.$set(
                                                personalizado,
                                                "valor",
                                                $$v
                                              )
                                            },
                                            expression: "personalizado.valor"
                                          }
                                        }),
                                        _c("b-form-invalid-feedback", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "newBillingForm.personalizado." +
                                                    personalizado.nombre +
                                                    ".valor"
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  : +personalizado.tipo ===
                                    _vm.customType.CUSTOM_TYPE_NUMBER
                                  ? _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-3",
                                        attrs: {
                                          "label-for":
                                            "newBillingForm.personalizado." +
                                            personalizado.nombre +
                                            ".valor",
                                          label: "Valor"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass: "w-full",
                                          attrs: {
                                            id:
                                              "newBillingForm.personalizado." +
                                              personalizado.nombre +
                                              ".valor",
                                            name:
                                              "newBillingForm.personalizado." +
                                              personalizado.nombre +
                                              ".valor",
                                            "data-cy":
                                              "newBillingForm.personalizado." +
                                              personalizado.nombre +
                                              ".valor",
                                            type: "number",
                                            "data-vv-as": personalizado.nombre,
                                            state: _vm.errors.has(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            )
                                              ? false
                                              : null,
                                            danger: _vm.errors.has(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            ),
                                            "danger-text": _vm.errors.first(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            )
                                          },
                                          model: {
                                            value: personalizado.valor,
                                            callback: function($$v) {
                                              _vm.$set(
                                                personalizado,
                                                "valor",
                                                $$v
                                              )
                                            },
                                            expression: "personalizado.valor"
                                          }
                                        }),
                                        _c("b-form-invalid-feedback", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "newBillingForm.personalizado." +
                                                    personalizado.nombre +
                                                    ".valor"
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  : +personalizado.tipo ===
                                    _vm.customType.CUSTOM_TYPE_OPTIONS
                                  ? _c(
                                      "b-form-group",
                                      { attrs: { label: "Valor (*)" } },
                                      [
                                        _c("v-select", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            autocomplete: "",
                                            name:
                                              "newBillingForm.personalizado." +
                                              personalizado.nombre +
                                              ".valor",
                                            state: _vm.errors.has(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            )
                                              ? false
                                              : null,
                                            danger: _vm.errors.has(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            ),
                                            "danger-text": _vm.errors.first(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            ),
                                            options: personalizado.opciones,
                                            reduce: function(option) {
                                              return option.valor
                                            },
                                            label: "descripcion",
                                            "data-vv-as": personalizado.nombre
                                          },
                                          model: {
                                            value: personalizado.valor,
                                            callback: function($$v) {
                                              _vm.$set(
                                                personalizado,
                                                "valor",
                                                $$v
                                              )
                                            },
                                            expression: "personalizado.valor"
                                          }
                                        }),
                                        _c("b-form-invalid-feedback", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "newBillingForm.personalizado." +
                                                    personalizado.nombre +
                                                    ".valor"
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  : +personalizado.tipo ===
                                    _vm.customType.CUSTOM_TYPE_CURRENCY
                                  ? _c(
                                      "b-form-group",
                                      { attrs: { label: "Valor (*)" } },
                                      [
                                        _c("v-select", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            autocomplete: "",
                                            name:
                                              "newBillingForm.personalizado." +
                                              personalizado.nombre +
                                              ".valor",
                                            state: _vm.errors.has(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            )
                                              ? false
                                              : null,
                                            danger: _vm.errors.has(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            ),
                                            "danger-text": _vm.errors.first(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            ),
                                            options: _vm.currencies,
                                            reduce: function(option) {
                                              return option.valor
                                            },
                                            label: "descripcion",
                                            "data-vv-as": personalizado.nombre
                                          },
                                          model: {
                                            value: personalizado.valor,
                                            callback: function($$v) {
                                              _vm.$set(
                                                personalizado,
                                                "valor",
                                                $$v
                                              )
                                            },
                                            expression: "personalizado.valor"
                                          }
                                        }),
                                        _c("b-form-invalid-feedback", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "newBillingForm.personalizado." +
                                                    personalizado.nombre +
                                                    ".valor"
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  : +personalizado.tipo ===
                                    _vm.customType.CUSTOM_TYPE_RATE_EXCHANGE
                                  ? _c(
                                      "b-form-group",
                                      { attrs: { label: "Valor (*)" } },
                                      [
                                        _c("v-select", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            autocomplete: "",
                                            name:
                                              "newBillingForm.personalizado." +
                                              personalizado.nombre +
                                              ".valor",
                                            state: _vm.errors.has(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            )
                                              ? false
                                              : null,
                                            danger: _vm.errors.has(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            ),
                                            "danger-text": _vm.errors.first(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            ),
                                            options: _vm.rateOfExchange,
                                            reduce: function(option) {
                                              return option.value
                                            },
                                            label: "label",
                                            "data-vv-as": personalizado.nombre
                                          },
                                          model: {
                                            value: personalizado.valor,
                                            callback: function($$v) {
                                              _vm.$set(
                                                personalizado,
                                                "valor",
                                                $$v
                                              )
                                            },
                                            expression: "personalizado.valor"
                                          }
                                        }),
                                        _c("b-form-invalid-feedback", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "newBillingForm.personalizado." +
                                                    personalizado.nombre +
                                                    ".valor"
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  : _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-3",
                                        attrs: {
                                          "label-for":
                                            "newBillingForm.personalizado." +
                                            personalizado.nombre +
                                            ".valor",
                                          label: "Valor"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass: "w-full",
                                          attrs: {
                                            id:
                                              "newBillingForm.personalizado." +
                                              personalizado.nombre +
                                              ".valor",
                                            name:
                                              "newBillingForm.personalizado." +
                                              personalizado.nombre +
                                              ".valor",
                                            "data-cy":
                                              "newBillingForm.personalizado." +
                                              personalizado.nombre +
                                              ".valor",
                                            type: "text",
                                            "data-vv-as":
                                              personalizado.descripcion,
                                            state: _vm.errors.has(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            )
                                              ? false
                                              : null,
                                            danger: _vm.errors.has(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            ),
                                            "danger-text": _vm.errors.first(
                                              "newBillingForm.personalizado." +
                                                personalizado.nombre +
                                                ".valor"
                                            )
                                          },
                                          model: {
                                            value: personalizado.valor,
                                            callback: function($$v) {
                                              _vm.$set(
                                                personalizado,
                                                "valor",
                                                $$v
                                              )
                                            },
                                            expression: "personalizado.valor"
                                          }
                                        }),
                                        _c("b-form-invalid-feedback", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "newBillingForm.personalizado." +
                                                    personalizado.nombre +
                                                    ".valor"
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      _c(
                        "form",
                        {
                          attrs: { novalidate: "", "data-vv-scope": "form-2" },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.addCustom("form-2")
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col col-1" }),
                            _c(
                              "div",
                              { staticClass: "col  col-3" },
                              [
                                _c(
                                  "b-form-group",
                                  { attrs: { label: "Tipo (*)" } },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        autocomplete: "",
                                        name:
                                          "newBillingForm.personalizado.new.tipo",
                                        options:
                                          _vm.customType.AVALAIBLE_CUSTOM_TYPES,
                                        "data-vv-as": "Tipo",
                                        reduce: function(option) {
                                          return option.valor
                                        }
                                      },
                                      model: {
                                        value: _vm.personalizado.tipo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.personalizado,
                                            "tipo",
                                            $$v
                                          )
                                        },
                                        expression: "personalizado.tipo"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col  col-3" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticClass: "mb-3",
                                    attrs: { label: "Nombre" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "w-full",
                                      attrs: {
                                        id:
                                          "newBillingForm.personalizado.new.nombre",
                                        name:
                                          "newBillingForm.personalizado.new.nombre",
                                        "data-cy":
                                          "newBillingForm.personalizado.new.nombre",
                                        "data-vv-as": "Nombre"
                                      },
                                      model: {
                                        value: _vm.personalizado.nombre,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.personalizado,
                                            "nombre",
                                            $$v
                                          )
                                        },
                                        expression: "personalizado.nombre"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "col col-1" },
                              [
                                _c("feather-icon", {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: "Agregar Personalizado",
                                      expression: "'Agregar Personalizado'"
                                    }
                                  ],
                                  staticClass: "mt-10 cursor-pointer",
                                  attrs: {
                                    size: "25",
                                    icon: "PlusCircleIcon",
                                    color: "green",
                                    "data-cy": "add-custom"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addCustom()
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ],
                    2
                  )
                ])
              ]),
              _c(
                "div",
                {
                  staticClass: "mt-5",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end"
                  }
                },
                [
                  _c(
                    "vs-button",
                    {
                      attrs: {
                        color: "dark",
                        type: "border",
                        "data-cy": "cancel-button"
                      },
                      on: {
                        click: function($event) {
                          return _vm.cancelNewBilling()
                        }
                      }
                    },
                    [_vm._v("Cancelar ")]
                  ),
                  _c(
                    "vs-button",
                    {
                      staticStyle: { "margin-left": "12px" },
                      attrs: {
                        color: "primary",
                        type: "border",
                        "data-cy": "save-button",
                        disable: _vm.saving
                      },
                      on: {
                        click: function($event) {
                          return _vm.newBilling()
                        }
                      }
                    },
                    [_vm._v(" Guardar ")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }